import type { GuestChatResponse, PropertySession, PropertyVisitor } from "@/types";
import { apiClient } from "./client";

export const propertyChatService = {
  /** Public: property-chat bootstrap; passing visitorId restores the session. */
  session: async (
    token: string,
    opts?: { lang?: string; visitorId?: string }
  ): Promise<PropertySession> => {
    const { data } = await apiClient.get<PropertySession>(`/property/${token}`, {
      params: {
        ...(opts?.lang ? { lang: opts.lang } : {}),
        ...(opts?.visitorId ? { visitor_id: opts.visitorId } : {}),
      },
    });
    return data;
  },

  /** Public: start a visitor session (first visit, after the name gate). */
  createVisitor: async (
    token: string,
    body: { name: string; lang: string }
  ): Promise<PropertyVisitor> => {
    const { data } = await apiClient.post<PropertyVisitor>(`/property/${token}/visitor`, body);
    return data;
  },

  /** Public: send a visitor message and get the concierge reply. */
  send: async (
    token: string,
    opts: { visitorId: string; message: string; lang?: string; guideId?: string }
  ): Promise<GuestChatResponse> => {
    const { data } = await apiClient.post<GuestChatResponse>(`/property/${token}/chat`, {
      visitor_id: opts.visitorId,
      message: opts.message,
      lang: opts.lang,
      guide_id: opts.guideId,
    });
    return data;
  },
};
